import _ from 'underscore';
import { createSelector } from 'reselect';

const subColumnDisplayName = (teachersById, cohortsById, subColumn) => {
  let name = subColumn.name;
  let participant;
  if(subColumn.type === 'teacher') {
    participant = teachersById[subColumn.value];
  }
  else if(subColumn.type === 'cohort') {
    participant = cohortsById[subColumn.value];
  }

  name = participant ? participant.displayName || participant.name : name;

  return name;
};

const columnSelector = createSelector(
  (viewerState, columns, selectedTeachers, selectedCohorts) => viewerState,
  (viewerState, columns, selectedTeachers, selectedCohorts) => columns,
  (viewerState, columns, selectedTeachers, selectedCohorts) => selectedTeachers,
  (viewerState, columns, selectedTeachers, selectedCohorts) => selectedCohorts,
  (viewerState, columns, selectedTeachers, selectedCohorts) => {

    let getKey = (index, name) => `${index}_${name}`;
    let teachersById = _.indexBy(selectedTeachers, 'id');
    let cohortsById = _.indexBy(selectedCohorts, 'id');

    let subColumns = _.groupBy(viewerState.selectedSubColumns, subColumn => {
      return getKey(subColumn.index, subColumn.name)
    });
    
    return columns.reduce((newColumns, column) => {
      let count = 0;
      column.selected = _.contains(viewerState.selectedColumns, column.name);
      column.hidden = _.contains(viewerState.hiddenColumns, column.name);
      column.className = 'abl-col-border';
      
      if(!column.hidden) {
        column.subColumns.items.forEach(subColumn => {
          let key = getKey(subColumn.column.index, subColumn.name);
          let isBorder = count > 0 && (count + 1) % column.subColumns.items.length  === 0;

          subColumn.selected = subColumns[key] !== undefined;
          subColumn.displayName = subColumnDisplayName(teachersById, cohortsById, subColumn);
          subColumn.iconName = subColumn.type.substr(0, 1);
          subColumn.className = isBorder ? column.className : '';
          count++;
        });
        newColumns.push(column);
      }
      
      return newColumns;
    }, []);
  }
);

export default columnSelector;


/** WEBPACK FOOTER **
 ** ./src/js/selectors/column_selector.js
 **/